import React from 'react';
import { connect } from 'react-redux';
import { List, Button, Icon } from 'antd';
import Preloader from '../../Preloader/Preloader';
import { getFilesToPublish, publishFile, downloadFile } from '../../../redux/actions/IC/ICActions';
import PublishFilesWrapper from './PublishFiles.style';

class PublishFiles extends React.Component {
  
  constructor() {
    super();
    this.handlePublishFile = this.handlePublishFile.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
  }

  componentDidMount() {
    this.props.getFilesToPublish();
  }

  handlePublishFile(key) {
    this.props.publishFile(this.props.ICREDUCER.files_to_publish[key]);
  }

  handleDownloadFile(key) {
    this.props.downloadFile(this.props.ICREDUCER.files_to_publish[key]);
  }
  
  render() {

    if(this.props.APPREDUCER.showPreloader === true) {
      return(
        <Preloader />
      )
    }
    else {
      const files_to_publish_list = this.props.ICREDUCER.files_to_publish;
      return(
        <PublishFilesWrapper>
          <h1>Publish Files section goes here</h1>
          <List
              header={<div className="flex header-publish-files-wrapper">
                        <p className="file-name">Name</p>
                        <p className="file-type">Type</p>
                        <p className="file-added-at">Added At Date</p>
                        <p className="file-download-link">Download</p>
                        <p className="file-publish">Action</p>
                      </div>}
              dataSource={files_to_publish_list}
              renderItem={(file,i) => (<List.Item key={i+1}>
                <div className="flex file-wrapper">
                  <p className="file-name">{file.name.split("(UTC)_")[1]}</p>
                  <p className="file-type">{file.type}</p>
                  <p className="file-added-at">{file.name.split("/")[1].split("_")[0].split("+")[0]}</p>
                  <div className="download-wrapper">
                    <Icon type="download" className="file-download-link" onClick={() => this.handleDownloadFile(i)} />
                  </div>
                  <Button type="primary" className="file-publish" onClick={() => this.handlePublishFile(i)}>PUBLISH</Button>
                </div>
                </List.Item>)}
              pagination={true}
            />
        </PublishFilesWrapper>
      )
    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  getFilesToPublish,
  publishFile,
  downloadFile
}

export default connect(mapStateToProps, mapDispatchToProps)(PublishFiles);


// WEBPACK FOOTER //
// ./src/components/IC/PublishFiles/PublishFiles.js